<template>
	<v-btn :small="small"
		   :disabled="!hasAccess || disabled"
		   icon class="assignee" :class="componentClass"
		   @click="onClick">
		<!--		<template v-if="owner">
					<v-btn v-if="owner" small icon :disabled="!isAuthed" @click="event=>onClick(event,'ownerAuth')">
						<avatar :user="owner"/>
					</v-btn>
					<v-icon small color="grey lighten-1">mdi-arrow-right</v-icon>
				</template>-->
		<template v-if="assignee">
			<avatar :user="assignee" :large="large" :small="small" :title="assigneeTitle"/>
			<!--			<avatar v-for="(companion, index) of companions" :key="index" :user="companion"/>-->
		</template>
		<template v-else-if="!disabled">
			<v-icon color="grey" :small="small" title="Выбрать ответственного">mdi-at</v-icon>
		</template>
	</v-btn>
</template>

<script>
import Base from "@/mixins/base";
import * as userUtils from "@/utils/user";

export default {
	name: "assignee",
	props: {
		item: {},
		small: {
			type: Boolean,
			default: false
		},
		large: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		property: {
			type: String,
			default: "userId"
		},
		/**
		 * Если задан - выбранный пользователь отдаётся этому обработчику без обращения к серверу
		 * (используется для черновика новой задачи).
		 */
		handler: {
			type: Function,
			default: undefined
		}
	},
	mixins: [Base],
	data: () => ({}),
	computed: {
		isVisible() {
			return this.item && !this.item.isNote && !this.isAnon;
		},
		isUnknownUser() {
			return this.assigneeId && !this.assignee;
		},
		assigneeId() {
			return this.item[this.property];
		},
		assignee() {
			if (!this.assigneeId) return null;
			//if ( this.isAnon && this.task.assignee && this.task.assignee.id === this.item.userId) return this.task.assignee;
			return this.users?.find(el => el.id === this.assigneeId);
		},
		assigneeTitle() {
			if (!this.assignee) return null;
			return "Ответственный: " + userUtils.nick(this.assignee);
		},
		controller() {
			if (this.item.controllerData?.length) {
				const nearestControllerId = this.item.controllerData[0].userId;
				return this.users?.find(el => el.id === nearestControllerId);
			}
			return null;
		},
		controllerTitle() {
			if (!this.controller) return null;
			return "Контроллер: " + userUtils.nick(this.controller);
		},
		/*owner() {
			if (!this.item.ownerId) return null;
			return this.users?.find(el => el.id === this.item.ownerId);
		},*/
		companions() {
			if (!this.item.companionAuths) return null;
			let companionAuths = this.item.companionAuths || [];
			if (typeof companionAuths === "string") companionAuths = JSON.parse(companionAuths);
			return companionAuths.map(id => this.area.users.find(el => el.id === id)).filter(el => !!el);
		},
		componentClass() {
			const c = [];
			//if (this.owner) c.push("--with-owner");
			if (this.large) c.push("--large");
			return c.length ? c : null;
		},
		hasAccess() {
			return this.hasFullAccessToTask(this.item);
		}
	},
	methods: {
		onClick(event) {
			event.preventDefault();
			if (this.handler) {
				return this.showMenuTaskAssign(this.item, this.property, event, {}, user => this.handler(user));
			}
			return this.$store.dispatch("ui/assignmentMenu", {event, item: this.item});
		},
	}
}
</script>

<style lang="scss">
.assignee {
	position: relative;
	z-index: 1;

	&.v-btn {
		display: flex;
		align-items: center;
		justify-content: center; //space-between;
		flex-shrink: 0;
		width: 24px;
		height: 24px;
		max-width: 24px;
		max-height: 24px;
	}

	&.--large {
		.v-btn {
			width: 32px;
			height: 32px;
			max-width: 32px;
			max-height: 32px;
		}
	}

}
</style>
